<div class="container">
    <div class="row no-gutters">
        <div
            class="col-lg col-12 d-flex align-items-center flex-grow-0 text-nowrap"
        >
            <div
                class="h4 mb-0"
                role="heading"
                aria-level="1"
            >
                <span>{{ _i18n._9548_OBSERVATION | translate }}</span
                >&nbsp;

                <span *ngIf="mode !== _ObservationControllerMode.REVIEW">
                    ({{
                        (!published ? _i18n._9476_DRAFT : _i18n._9113_PUBLISHED)
                            | translate
                    }})
                </span>

                <span *ngIf="mode === _ObservationControllerMode.REVIEW">
                    <ng-container *ngIf="!allowedActions?.cancel">
                        ({{ _i18n._9701_READ_ONLY | translate }})
                    </ng-container>
                    <ng-container
                        *ngIf="allowedActions?.cancel && enabledActions?.cancel"
                    >
                        ({{ _i18n._9702_EDIT_MODE | translate }})
                    </ng-container>
                </span>
            </div>

            <ng-container *ngIf="mode === _ObservationControllerMode.REVIEW">
                <button
                    class="ml-2 cmps-button--no-bg"
                    cmpsButton
                    [disabled]="!enabledActions?.cancel"
                    data-e2e="button-cancel-review"
                    (click)="cancel.emit()"
                    *ngIf="allowedActions?.cancel"
                >
                    <span cmpsButtonLabel>{{
                        _i18n._9637_EXIT_EDIT_MODE | translate
                    }}</span>
                </button>
            </ng-container>
        </div>

        <div class="col-lg col-12 d-flex flex-grow-1 justify-content-lg-end">
            <cmps-wait-status *ngIf="pending"></cmps-wait-status>
            <button
                class="ml-2 cmps-button--no-bg"
                cmpsButton
                [disabled]="!enabledActions?.cancel"
                data-e2e="button-cancel-default"
                (click)="cancel.emit()"
                *ngIf="
                    mode !== _ObservationControllerMode.REVIEW &&
                    allowedActions?.cancel
                "
            >
                <cmps-icon svgIcon="exit-to-app"></cmps-icon>
                <span cmpsButtonLabel>{{ _i18n._121_CANCEL | translate }}</span>
            </button>
            <button
                class="cmps-button--no-bg"
                cmpsButton
                [disabled]="!enabledActions?.share"
                (click)="share.emit()"
                *ngIf="allowedActions?.share"
            >
                <cmps-icon svgIcon="share-variant"></cmps-icon>
                <span cmpsButtonLabel>{{ _i18n._9630_SHARE | translate }}</span>
            </button>
            <button
                class="cmps-button--no-bg"
                cmpsButton
                [disabled]="!enabledActions?.edit"
                (click)="edit.emit()"
                *ngIf="allowedActions?.edit"
            >
                <cmps-icon svgIcon="pencil"></cmps-icon>
                <span cmpsButtonLabel>{{ _i18n._7425_EDIT | translate }}</span>
            </button>
            <button
                class="cmps-button--no-bg"
                cmpsButton
                [disabled]="!enabledActions?.delete"
                (click)="delete.emit()"
                *ngIf="allowedActions?.delete"
            >
                <cmps-icon svgIcon="delete"></cmps-icon>
                <span cmpsButtonLabel>{{
                    _i18n._7424_DELETE | translate
                }}</span>
            </button>
            <button
                class="cmps-button--no-bg"
                cmpsButton
                [disabled]="!enabledActions?.publish"
                data-e2e="button-publish"
                (click)="publish.emit()"
                *ngIf="allowedActions?.publish"
            >
                <cmps-icon
                    class="oncr-publish-rotate-45"
                    svgIcon="send"
                ></cmps-icon
                >&nbsp;
                <span cmpsButtonLabel>{{
                    _i18n._9415_PUBLISH | translate
                }}</span>
            </button>
            <button
                class="cmps-button--no-bg"
                cmpsButton
                [disabled]="!enabledActions?.save || !dirty"
                data-e2e="button-save"
                (click)="save.emit()"
                *ngIf="allowedActions?.save"
            >
                <cmps-icon svgIcon="content-save"></cmps-icon>
                <span cmpsButtonLabel>{{
                    _i18n._9416_SAVE_DRAFT | translate
                }}</span>
            </button>
            <button
                class="pl-5 cmps-icon-button--no-bg"
                cmpsIconButton
                (click)="_onCloseToDetailClick()"
                *ngIf="mode === _ObservationControllerMode.DEFAULT"
            >
                <cmps-icon svgIcon="close"></cmps-icon>
            </button>
        </div>
    </div>
</div>
